import { lazy } from "react";
import RoleSwitch from "modules/swiftboard/components/RoleSwitch";

// /swiftboard/home — each role has its own home page. Any other role
// (e.g. one created later) gets DefaultHome.
const pages = {
  SUPER_ADMIN: lazy(() => import("./super-admin/SuperAdminHome")),
  ADMIN:       lazy(() => import("./admin/page")),
  CLIENT:      lazy(() => import("./client/page")),
  EMPLOYEE:    lazy(() => import("./employee/page")),
};

const DefaultHome = lazy(() => import("./default/DefaultHome"));

export default function Home() {
  return <RoleSwitch pages={pages} fallback={DefaultHome} />;
}
